export const {
    VUE_APP_Gateway_API,
} = process.env;
